import React, { useContext, useEffect } from 'react'
import GameRate from '../03-game-rate/GameRate'
import MarketResult from '../04-market-result/MarketResult'
import StarlineResult from '../05-starline-result/StarlineResult'
import HowToPlay from '../06-how-to-play/HowToPlay'
import GetTheApp from '../07-get-app/GetTheApp'
import Header from '../02-header/Header'
import { LoaderContext } from '../15-loader/LoaderProvider'
import Loader from '../15-loader/Loader'
import WhyChooseUs from '../02-why-choose-us/WhyChooseUs'
import { useLocation } from 'react-router-dom'

const Home = () => {

  const { isLoading } = useContext(LoaderContext);

  const location = useLocation();
  
  useEffect(() => {
    
      if(location.pathname == '/howtoplay'){
        const element = document.getElementById('howtoplay')
        if(element){
          element.scrollIntoView({behavior: 'instant'})
        }
      }
    
  }, [location])

  // useEffect(() => {
  //   if (location.hash) {
  //     const targetId = location.hash.substring(1);

  //     console.log(targetId);
  //     const targetElement = document.getElementById(targetId);
  //     if (targetElement) {
  //       targetElement.scrollIntoView({ 
  //         behavior: 'instant',
  //         offset: -500
  //       });
  //     }
  //   }
  // }, [location]);
  


  return (
    <div>

      {/* {
           isLoading ? <Loader/> :

           <> */}

      <Header />
      <WhyChooseUs />
      <GameRate />
      <MarketResult />
      <StarlineResult />
      <HowToPlay />
      <GetTheApp />

      {/* </>

      } */}

    </div>
  )
}

export default Home
